import { render, staticRenderFns } from "./ClrmButton.vue?vue&type=template&id=81c41112&scoped=true&"
import script from "./ClrmButton.vue?vue&type=script&lang=js&"
export * from "./ClrmButton.vue?vue&type=script&lang=js&"
import style0 from "./ClrmButton.vue?vue&type=style&index=0&id=81c41112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c41112",
  null
  
)

export default component.exports